import React from 'react'
import profile from '../../assets/profile.png'
import moment from 'moment'
import {useNavigate} from 'react-router-dom'

const ProfileCard = ({user, id, staff}) => {
    const navigate = useNavigate()
  return (
    <div className='profile__card'>
        <div className="profile__card-content">
            <img src={!staff?.profilePic && !user?.profilePic ? profile
            : `https://backend.aspomportal.com/upload/${staff?.profilePic || user?.profilePic}`} 
            alt={staff?.firstName + ' ' + staff?.lastName || user?.firstName + ' ' + user?.lastName}
            className="profile__card-img" />
            <div className="profile__card-details">
                <h4 className="profile__card-name">
                    {staff?.firstName ? staff?.firstName + ' ' + staff?.lastName 
                    : user?.firstName + ' ' + user?.lastName}
                </h4>
                <span className="profile__card-dept">
                    {staff?.department || user?.department}
                </span>
                <span className="profile__card-role">
                    {staff?.department ? staff?.department + ' ' + staff?.role : staff?.role
                    || user?.department ? user?.department + ' ' + user?.role : user?.role}
                </span>
                <h5 className="profile__card-id">
                    Staff ID: {staff?.stafId || user?.staffId}
                </h5>
                <div className="profile__card-date">
                    Join on {moment(staff?.createdAt || user?.createdAt).format('DD MMMM YYYY')}
                </div>
                {
                    id && <div className="profile__card-buttons">
                        <button onClick={()=>navigate(`/chat_room/${id}`)}
                        className="profile__card-btn button">
                            Chat
                        </button>
                        <button onClick={()=>navigate('/email')}
                        className="profile__card-btn button">
                            Email
                        </button>
                    </div>
                }
            </div>
        </div>
        <div className="profile__card-summary">
            <div className="profile__card-summary_div">
                <h4 className="profile__card-summary_title">Phone:</h4>
                <span className="profile__card-sumary_value">
                    {staff?.phone || user?.phone}
                </span>
            </div>
            <div className="profile__card-summary_div">
                <h4 className="profile__card-summary_title">Email:</h4>
                <span className="profile__card-sumary_value">
                    {staff?.email || user?.email}
                </span>
            </div>
            <div className="profile__card-summary_div">
                <h4 className="profile__card-summary_title">Gender:</h4>
                <span className="profile__card-sumary_value">
                    {staff?.gender || user?.gender}
                </span>
            </div>
            <div className="profile__card-summary_div">
                <h4 className="profile__card-summary_title">Birthday:</h4>
                <span className="profile__card-sumary_value">
                    {staff?.birthDay || user?.birthDay}
                </span>
            </div>
            <div className="profile__card-summary_div">
                <h4 className="profile__card-summary_title">Address:</h4>
                <span className="profile__card-sumary_value">
                    {staff?.address?.street || user?.address?.street}
                </span>
            </div>
            <div className="profile__card-summary_div">
                <h4 className="profile__card-summary_title">State:</h4>
                <span className="profile__card-sumary_value">
                    {staff?.address?.state || user?.address?.state}
                </span>
            </div>
            <div className="profile__card-summary_div">
                <h4 className="profile__card-summary_title">Nationality:</h4>
                <span className="profile__card-sumary_value">
                    {staff?.address?.country || user?.address?.country}
                </span>
            </div>
        </div>
    </div>
  )
}

export default ProfileCard